//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  watch: {
    activeTab(tab) {
      this.$emit("toggle", tab);
    },
  },
  data() {
    return {
      activeTab: "Tab 1",
    };
  },
  props: {
    iconMode: {
      default: false,
    },
    tabs: {
      type: Array,
      default: () => {
        return ["Tab 1", "Tab 2"];
      },
    },
  },
  mounted() {
    this.activeTab = this.tabs[0];
  },
};
